
import { parseChannelIdBySessionKey } from "./chat_base";
import { createTuituiClient } from "./sdk";

export async function getChannelInfoByChannelId(account: any, channel_id: string): Promise<any> {
  return await createTuituiClient(account).teams.getChannelInfo(channel_id);
}

export interface TuiTuiChannelPostTag {
  tag_id: string;
  name?: string;
}

export async function getChannelPostTags(account: any, channel_id: string): Promise<TuiTuiChannelPostTag[]> {
  return await createTuituiClient(account).teams.getChannelPostTags(channel_id);
}

// TODO: 支持群公告
export async function teams_get_announcement(account: any, id: any, id_is_session: boolean = true): Promise<any> {
  let channel_id = id;
  if(id_is_session) {
    channel_id = parseChannelIdBySessionKey(id);
    if(!channel_id) {
      return "";
    }
  }

  const info = await getChannelInfoByChannelId(account, channel_id);
  const announcement = info?.announcement;
  return announcement;
}


export async function teams_get_members(account: any, team_id: string): Promise<any> {
  return await createTuituiClient(account).teams.getMembers(team_id);
}

export async function teams_get_members_text(account: any, team_id: string): Promise<string> {
  return await createTuituiClient(account).teams.getMemberNames(team_id);
}
